// Dependencies.

import { HowToParticipate } from './HowToParticipate'
import { WhatToBring } from './WhatToBring'
import { HostBio } from './HostBio'
import { EventHookInterface } from '../../../types'
import { Participants } from './Participants'
import { WhoToInvite } from '../Hero/WhoToInvite'

// Props.
interface Props {
  eventHook: EventHookInterface
}

// Text Fields.
export const TextFields: React.FC<Props> = (props) => {
  const { eventHook } = props

  // ..
  return (
    <>
      {/* How To Participate. */}
      {/* {(eventHook.isEditable || eventHook.value.participation_descr)
      ? <HowToParticipate eventHook={eventHook} />
      : null} */}
      {/* Removing how to participate */}
      {eventHook.value.participation_descr ? (
        <HowToParticipate eventHook={eventHook} />
      ) : null}

      {/* What To Bring. */}
      {/* {(eventHook.isEditable || eventHook.value.equipments.length)
      ? <WhatToBring eventHook={eventHook} />
      : null} */}
      {/* Removing what to bring from create */}
      {eventHook.value.equipments.length ? (
        <WhatToBring eventHook={eventHook} />
      ) : null}
      {/* Host Bio. */}
      {!eventHook.isEditable && <HostBio eventHook={eventHook} />}

      {/* Participants. */}
      <Participants eventHook={eventHook} />

      {/* Who To Invite. */}
      <WhoToInvite eventHook={eventHook} />
    </>
  )
}
